import _ from 'lodash';

const defaultState = {
	projects: [],
	projectsCount: 0,
	projectsLoading: false,
	projectsEmpty: false,
	permissions: { canEdit: false, editPrivileges: { roleModules: [] } },
	permissionsModule: { },
	notifications: [],
	info: { fmsids: [], contracts: [], secondaryFmsS: [] },
	members: [],
	consultants: [],
	contractors: [],
	contracts: [],
	budgets: [],
	documents: [],
	schedule: {},
	locations: [],
	gisObjects: [],
	delayLogs: [],
	progressReports: [],
	progressReport: null,
	documentTags: [],
	divisionName: 'Public Buildings',
	isScheduleEditDisabled: false,
	p6UpdatedDate:'',
	groupName: 2,
	memberSearchResults: [],
	adjustmentLogs: [],
	projectTitles: [],
	setup: {},
	detailBackUrl: '/search',
	statusComments: [],
	statusCommentDetails: [],
	actionItems: [],
	actionItemCategories: [],
	actionItemPriorities: [],
	actionItemAssignees: [],
	actionItemItems: [],
	actionItemMembers: [],
	actionItemStatuses: [],
	statusCommentTypes: [],
	activitiesIssues: [],
	blueBooks: [],
	bidPackages: [],
	bPkgStList: [],
	chartData:[],
	bidPkgStatuses: [],
	bidPkgCheckListStatuses: [],
	gisCouncil: [],
	gisAssemblyDist: [],
	gisCommBoard: [],
	gisStateSenateDist: [],
	gisUSCongressionalDist: [],
	factSheet: {},
	contractorFieldInfos: [],
	crStatuses: [],
	constrReview: {},
	contractsProc:[],
	contractsForDivision: [],
	AEBidPkgReport: [],
	currentPage: 0,
	currentPageAEprojects: 0,
	projectsCountAEprojects: 0,
	subPhases: [{phaseName: 'Development', subPhases: ['Development'] , divisionName: 'Public Buildings' },
	{phaseName: 'FEP', subPhases: ['Draft CPI Review', 'Client Agency Review/Sign-Off', 'Pre-preliminary Design']  , divisionName: 'Public Buildings' },

	{ phaseName: 'Initiation', subPhases: ['CPI Received', 'In-House Design Initiation', 'Design Procurement'], divisionName: 'Public Buildings' },
	{phaseName: 'Design', subPhases: ['Project Objectives', 'Pre-Schematic Design', 'Schematic Design', 'Design Development', 'Combined SD & DD', 'Combined SD & DD & 75% CD', '75% Construction Documents', '100% Construction Documents'], divisionName: 'Public Buildings'
	},
	{phaseName: 'Procurement', divisionName: 'Public Buildings'
		, subPhases: ['In Legal', 'Schedule Bid Avertisement', 'Bid Dates', 'Pre Award / APT', 'Award', 'Execution', 'Registration']
	},
	{phaseName: 'Construction', divisionName: 'Public Buildings'
		, subPhases: ['Preconstruction', 'Construction 0-25%', 'Construction 25-50%', 'Construction 50-75%', 'Construction 75%-100%']
	},
	{phaseName: 'Substantially Completed', divisionName: 'Public Buildings'
		, subPhases: ['Warranty Period', 'Project Acceptance', 'Close-Out documents']
	},

	{ phaseName: 'Development', subPhases: ['Development'], divisionName: 'Infrastructure' },
	{ phaseName: 'FEP', subPhases: ['Draft CPI Review', 'Client Agency Review/Sign-Off', 'Pre-preliminary Design'], divisionName: 'Infrastructure' },
	{ phaseName: 'Initiation', subPhases: ['CPI Received', 'In-House Design Initiation', 'Design Procurement'], divisionName: 'Infrastructure' },
	{
		phaseName: 'Design', subPhases: ['Preliminary Design', 'Preliminary design  (40%)', '75% Design ', '100% Design', 'Bid Pacakge Review',
			'In Legal'], divisionName: 'Infrastructure'
	},
	{
		phaseName: 'Procurement', divisionName: 'Infrastructure'
		, subPhases: ['Schedule Bid Avertisement', 'Bid Dates', 'Pre Award / APT', 'Award', 'Execution', 'Registration']
	},
	{
		phaseName: 'Construction', divisionName: 'Infrastructure'
		, subPhases: ['Preconstruction', 'Construction 0-25%', 'Construction 25-50%', 'Construction 50-75%', 'Construction 75%-100%']
	},
	{
		phaseName: 'Substantial Completion', divisionName: 'Infrastructure'
		, subPhases: ['Substantial Completion']
	},
	{
		phaseName: 'Closeout', divisionName: 'Infrastructure'
		, subPhases: ['Closeout']
	},

	],
	benchmarkStatuses: ['Active','On-Hold', 'Completed', 'Cancelled'],
	projectsAE: [],
	documentsFep: [],
	piaPdf: null
};

function findProject(projects, id) {
	const project = _.find(projects, { projectId: id });
	if (project) {
		const { projectTeams, fmsids, schedule, ...info } = project;
		info.fmsids = fmsids.map(obj => obj.fmsid);

		return {
			info,
			schedule,
			members: projectTeams,
			divisionName: info.divisionName,
			isScheduleEditDisabled: info.isScheduleEditDisabled,
			p6UpdatedDate: info.p6UpdatedDate
		}
	} else {
		return {
			info: defaultState.info,
			schedule: defaultState.schedule,
			members: defaultState.members,
			divisionName: defaultState.divisionName,
			isScheduleEditDisabled : defaultState.isScheduleEditDisabled,
			p6UpdatedDate: defaultState.p6UpdatedDate
		}
	}
}

function digestInfo(data) {
	const { projectTeams, fmsids, schedule, contractors, gisLocations, contracts, secondaryFmsS, ...info } = data;

	info.fmsids = fmsids.map(obj => obj.fmsid);
	info.contracts = contracts;
	info.secondaryFmsS = secondaryFmsS.map(obj => obj.fmsid);

	return {
		info,
		schedule,
		contractors,
		members: projectTeams,
		budgets: fmsids,
		locations: gisLocations,
		divisionName: info.divisionName,
		isScheduleEditDisabled: info.isScheduleEditDisabled,
		p6UpdatedDate: info.p6UpdatedDate
	}
}

function digestProjects(data) {
	return {
		projectsCount: data.count,
		projectsEmpty: data.count === 0,
		projects: data.entries || [],
		currentPage: data.currentPage,
	}
}

function digestProjectsAE(data) {
	return {
		projectsCountAEprojects: data.count,
		projectsEmpty: data.count === 0,
		projectsAE: data.entries || [],
		currentPageAEprojects: data.currentPage,
	}
}
function errorResults(msg) {
	return {
		projectsCount: 0,
		projectsEmpty:  0,
		projects: [],
		currentPage: 0,
		errorMessage: msg
	}
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case 'FETCH_PROJECTS_FULFILLED':
			return {
				...state,
				...digestProjects(action.payload.data),
			}

		case 'FETCH_PROJECTS_FULFILLED_AE':
			return {
				...state,
				...digestProjectsAE(action.payload.data),
			}

		case 'SET_PROJECTS_LOADING':
			return {
				...state,
				projectsLoading: action.payload,
			}

		/* Following cases return without any break */
		case 'FETCH_INFO_FULFILLED':
			return {
				...state,
				...digestInfo(action.payload.data),
			}

		case 'FETCH_PERMISSIONS_FULFILLED':
			return {
				...state,
				permissions: { ...action.payload.data },
			}
		case 'FETCH_PERMISSIONS_FULFILLED_MODULE':
			return {
				...state,
				permissionsModule: { ...action.payload.data },
			}

		case 'FETCH_PIA_PDF_FULFILLED':
			return {
				...state,
				piaPdf: { ...action.payload.data },
			}

		case 'FETCH_NOTIFICATIONS_FULFILLED':
			return {
				...state,
				notifications: [...action.payload.data.entries],
			}

		case 'FETCH_MEMBERS_FULFILLED':
			return {
				...state,
				members: [...action.payload.data.entries]
			}

		case 'FETCH_CONSULTANTS_FULFILLED':
			return {
				...state,
				consultants: [...action.payload.data.entries]
			}

		case 'FETCH_CONTRACTORS_FULFILLED':
			return {
				...state,
				contractors: [...action.payload.data]
			}

		case 'FETCH_PROJECT_TITLES_FULFILLED':
			return {
				...state,
				projectTitles: action.payload.data.entries,
			}

		case 'FETCH_BUDGETS_FULFILLED':
			return {
				...state,
				budgets: [...action.payload.data]
			}

		case 'FETCH_DOCUMENTS_FULFILLED':
			return {
				...state,
				documents: [...action.payload.data.entries,],
				count: action.payload.data.count,
				pageSize: action.payload.data.pageSize
			}

		case 'FETCH_DOCUMENT_TAGS_FULFILLED':
			return {
				...state,
				documentTags: [...action.payload.data]
			}

		case 'FETCH_LOCATIONS_FULFILLED':
			return {
				...state,
				locations: [...action.payload.data.entries,]
			}

		case 'FETCH_GISOBJECTS_FULFILLED':
			return {
				...state,
				gisObjects: [...action.payload.data.entries]
			}

		case 'FETCH_SCHEDULE_FULFILLED':
			return {
				...state,
				schedule: action.payload.data
			}

		case 'FETCH_ADJUSTMENT_LOGS_FULFILLED':
			return {
				...state,
				adjustmentLogs: [...action.payload.data.entries]
			}

		case 'FETCH_DELAY_LOGS_FULFILLED':
			return {
				...state,
				delayLogs: [...action.payload.data.entries],
			}

		case 'FETCH_STATUS_COMMENTS_FULFILLED':
			return {
				...state,
				statusComments: [...action.payload.data.entries],
			}

		case 'FETCH_STATUS_COMMENTDETAILS_FULFILLED':
			return {
				...state,
				statusCommentDetails: [...action.payload.data.entries],
			}

		case 'FETCH_CONTRACTS_FULFILLED':
			return {
				...state,
				contracts: [...action.payload.data.entries],
			}

		case 'FETCH_PROGRESS_REPORTS_FULFILLED':
			return {
				...state,
				progressReports: [...action.payload.data.entries],
			}

		case 'FETCH_PROGRESS_REPORT_FULFILLED':
			return {
				...state,
				progressReport: action.payload.data
			}

		case 'FETCH_MEMBER_SEARCH_FULFILLED':
			return {
				...state,
				memberSearchResults: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_FULFILLED':
			return {
				...state,
				actionItems: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_CATEGORY_FULFILLED':
			return {
				...state,
				actionItemCategories: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_PRIORITY_FULFILLED':
			return {
				...state,
				actionItemPriorities: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_ITEMS_FULFILLED':
			return {
				...state,
				actionItemItems: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_ASSIGNEE_FULFILLED':
			return {
				...state,
				actionItemAssignees: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_MEMBER_FULFILLED':
			return {
				...state,
				actionItemMembers: action.payload.data.entries,
			}

		case 'FETCH_ACTIONITEM_STATUS_FULFILLED':
			return {
				...state,
				actionItemStatuses: action.payload.data.entries,
			}


		case 'FETCH_STATUSCOMMENT_TYPE_FULFILLED':
			return {
				...state,
				statusCommentTypes: action.payload.data.entries,
			}

		case 'FETCH_ACTIVITIES_ISSUES_FULFILLED':
			return {
				...state,
				activitiesIssues: action.payload.data.entries,
			}

		case 'FETCH_SETUP_FULFILLED':
			return {
				...state,
				setup: { ...action.payload.data },
			}

		case 'SET_WATCH_VALUE':
			return {
				...state,
				projects: state.projects.map(project => {
					if (project.projectId !== action.payload.projectId) return project;
					return { ...project, inWatchlist: action.payload.inWatchlist }
				})
			}

		case 'SET_CURRENT_PROJECT':
			var project = findProject(state.projects, action.payload);
			return {
				...state,
				...project,
			}

		case 'SET_CURRENT_INFO':
			return {
				...state,
				info: action.data
			}

		case 'SET_CURRENT_SCHEDULE':
			return {
				...state,
				schedule: action.data
			}

		case 'FETCH_ADVANCE_SEARCH_FULLFILLED':
			return {
				...state,
				projects: action.payload.data.entries
			}

		case 'FETCH_BID_PACKAGES_FULFILLED':
			return {
				...state,
				bidPackages: action.payload.data.entries
			}

		case 'FETCH_BID_PACKAGE_STATUS_FULFILLED':
			return {
				...state,
				bidPkgStatuses: action.payload.data.entries,
			}

		case 'FETCH_BID_PKG_CHECKLIST_STATUS_FULFILLED':
			return {
				...state,
				bidPkgCheckListStatuses: action.payload.data.entries,
			}

		case 'FETCH_bPkgStList':
			return {
				...state,
				bPkgStList: action.payload.data.entries,
			}

		case 'FETCH_GIS_COUNCIL_FULFILLED':
			return {
				...state,
				gisCouncil: action.payload.data.entries,
			}

		case 'FETCH_GIS_ASSEMBLY_DISTRICT_FULFILLED':
			return {
				...state,
				gisAssemblyDist: action.payload.data.entries,
			}

		case 'FETCH_GIS_COMMUNITY_BOARD_FULFILLED':
			return {
				...state,
				gisCommBoard: action.payload.data.entries,
			}
		case 'FETCH_GIS_STATE_SENATE_DISTRICT_FULFILLED':
			return {
				...state,
				gisStateSenateDist: action.payload.data.entries,
			}
		case 'FETCH_GIS_US_CONGRESSIONAL_DISTRICT_FULFILLED':
			return {
				...state,
				gisUSCongressionalDist: action.payload.data.entries,
			}

		case 'FETCH_FACT_SHEET_FULFILLED':
			return {
				...state,
				factSheet: { ...action.payload.data },
			}

		case 'FETCH_CONSTR_REVIEW_STATUS_FULFILLED':
			return {
				...state,
				crStatuses: action.payload.data.entries,
			}

		case 'FETCH_CONSTR_REVIEW_FULFILLED':
			return {
				...state,
				constrReview: { ...action.payload.data },
			}

		case 'EMPTY_PROJECTS':
			return {
				...state,
				projects: defaultState.projects,
				projectsCount: defaultState.projectsCount,
				projectsEmpty: false,
			}

		case 'SET_BACK_FOR_DETAIL':
			return {
				...state,
				detailBackUrl: action.payload,
				errorMessage: undefined
			}

		case 'FETCH_CHART_BY_OBS':
			return {
				...state,
				chartData: action.payload.data.entries,
			}

		case 'FETCH_BLUEBOOKS':
			return {
				...state,
				blueBooks: action.payload.data.entries,
			}

		case 'FETCH_DOCUMENTS_FEP_FULFILLED':
			return {
				...state,
				documentsFep:  [...action.payload.data.entries,],
			}

		case 'FETCH_CONTRACTORFIELDINFO':
			return {
				...state,
				contractorFieldInfos: action.payload.data.entries,
			}

		case 'FETCH_CONTRACTSPROC_FULFILLED':
			return {
				...state,
				contractsProc: [...action.payload.data.entries],
			}

		case 'FETCH_CONTRACTS_FOR_DIVISION_FULFILLED':
			return {
				...state,
				contractsForDivision: [...action.payload.data.entries],
			}
		case 'FETCH_AEBIDPKG_REPORT':
			return {
				...state,
				AEBidPkgReport: [...action.payload.data.entries],
			}
		case 'FETCH_FAILED':
			return {
				...state,
				...errorResults('Something went wrong. Please try again later.'),
			}
		default:
			return state;
	}


}


